import { render, staticRenderFns } from "./TotalOrderByDistributor.vue?vue&type=template&id=f900f874&"
import script from "./TotalOrderByDistributor.vue?vue&type=script&lang=js&"
export * from "./TotalOrderByDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports